import { Campaign, CampaignChangeRequest } from '../../../types/Campaign';
import { useEffect, useState } from 'react';
import ApiService from '../../../ApiService';
import CDGrid from '../../../components/CDGrid';
import { GridColDef } from '@mui/x-data-grid';
import Utils from '../../../components/Utils';
import { Box, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CDButton from '../../../components/CDButton';

export default function ChangeRequestTab(props: { campaign: Campaign }) {
    const { campaign } = props;
    const navigate = useNavigate();

    const [campaignChangeRequests, setCampaignChangeRequests] = useState<CampaignChangeRequest[]>([]);

    useEffect(() => {
        if (campaign.id) {
            ApiService.getCampaignChangeRequests(campaign.id).then((response) => {
                setCampaignChangeRequests(response.data);
            });
        }
    }, [campaign]);

    const columns: GridColDef[] = [
        {
            field: 'modifiedDate',
            headerName: 'Requested',
            width: 100,
            renderCell: (params) => {
                return Utils.formatDate(params.value);
            },
            display: 'flex',
        },
        {
            field: 'modifiedByUser',
            headerName: 'Requested By',
            width: 130,
            flex: 1,
            valueGetter: (value: { name: string }) => {
                return value.name;
            },
            display: 'flex',
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 120,
            renderCell: (params) => {
                return (
                    <Chip
                        size="small"
                        label={params.value}
                        color={
                            params.value === 'Pending' ? 'warning' : params.value === 'Declined' ? 'error' : 'success'
                        }
                    />
                );
            },
            display: 'flex',
        },
        {
            field: 'dealer',
            headerName: 'Advertiser',
            width: 160,
            flex: 2,
            valueGetter: (value: { dealerName: string }) => {
                return value.dealerName;
            },
            display: 'flex',
        },
        {
            field: 'budget',
            headerName: 'Budget',
            align: 'right',
            headerAlign: 'right',
            flex: 1,
            cellClassName: (params) => {
                if (campaign.budget !== params.value) {
                    return 'modified';
                } else {
                    return '';
                }
            },
            renderCell: (params) => {
                return Utils.formatCurrency(params.value);
            },
            display: 'flex',
        },
        {
            field: 'impressionGoal',
            headerName: 'Impressions',
            align: 'right',
            headerAlign: 'right',
            flex: 1,
            cellClassName: (params) => {
                if (campaign.impressionGoal !== params.value) {
                    return 'modified';
                } else {
                    return '';
                }
            },
            renderCell: (params) => {
                return Utils.formatNumber(params.value);
            },
            display: 'flex',
        },
        {
            field: 'startDate',
            headerName: 'Start Date',
            flex: 1,
            renderCell: (params) => {
                return Utils.formatDate(params.value);
            },
            display: 'flex',
        },
        {
            field: 'endDate',
            headerName: 'End Date',
            flex: 1,
            renderCell: (params) => {
                return Utils.formatDate(params.value);
            },
            display: 'flex',
        },
        {
            field: '-',
            headerName: 'Actions',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => {
                return (
                    <CDButton
                        variant="text"
                        onClick={() => {
                            navigate('/campaign/' + params.row.id, {
                                state: {
                                    isChangeRequest: true,
                                    campaignId: campaign.id,
                                    changeRequestId: params.row.id,
                                },
                            });
                        }}
                    >
                        {params.row.status === 'Pending' ? 'View / Modify' : 'View'}
                    </CDButton>
                );
            },
            display: 'flex',
        },
    ];

    return (
        <>
            <Box
                sx={{
                    '& .modified': {
                        fontWeight: 'bold',
                    },
                }}
            >
                <CDGrid
                    // onRowClick={(params) => {
                    //     navigate('/campaign/' + params.row.id, {
                    //         state: {
                    //             isChangeRequest: true,
                    //             campaignId: campaign.id,
                    //             changeRequestId: params.row.id,
                    //         },
                    //     });
                    // }}
                    columns={columns}
                    rows={campaignChangeRequests}
                />
            </Box>
        </>
    );
}
